export const classes = {
    'App' : 'TBS_ROOT',
    'Problem' : 'TBS_PROBLEM',
    'CommentBox' : 'TBS_COMMENT_BOX',
    'ReviewBox' : 'TBS_REVIEW_BOX',
    'BookmarkTab' : 'TBS_BOOKMARK_TAB',
    'MobileTab' : 'TBS_MOBILE_TAB',
    'Step' : 'TBS_SOLUTION_STEP',
    'TOC' : 'TBS_TOC',
    'Toolbar' : 'TBS_TOOLBAR',
    'ToolbarNavigation' : 'TBS_TOOLBAR_WITH_DROPDOWNS',
    'Tooltip' : 'TBS_TOOLTIP',
    'Solution' : 'TBS_SOLUTION',
    'ErrorDialog' : 'TBS_ERROR_DIALOG',
    'NoSolution' : 'TBS_NO_SOLUTION',
    'NoSubSolution' : 'TBS_NO_SUBSCRIPTION',
    'Loader' : 'TBS_LOADER'
};

export function getHookClass(key){
    return classes[key] || '';
}

export function getHookClassString(key){
    return classes[key] ? '.' + classes[key] : '';
}



// WEBPACK FOOTER //
// ./src/helpers/cssHooks.js